import script from "./VerticalMarket.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerticalMarket.vue?vue&type=script&setup=true&lang=ts"

import "./VerticalMarket.vue?vue&type=style&index=0&id=185f188e&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-185f188e"]])

export default __exports__